import React, { useEffect, useRef, useState } from "react";
import { effectiveStatus } from 'helpers/effectiveStatus';
import { useNavigate, useParams } from "react-router-dom";

import { fetchAppointmentView } from "slices/appointmentSlice";
import { useDispatch, useSelector } from "react-redux";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import toast from "react-hot-toast";
import { setActionAssign } from "slices/actionButtonSlice";
import CancelModal from "components/appointment/CancelModal";
import DonotCover from "components/appointment/DonotCover";
import RescheduleModal from "components/appointment/RescheduleModal";
import { fetchAppointmentLogs } from "slices/appointmentSlice";
import LogsTable from "./LogsTable";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup } from "slices/appointmentSlice";
import { removeAppointment } from "slices/appointmentSlice";
import Swal from "sweetalert2";
import SelectInterpreterModal from "components/common/SelectInterpreterModal";
import SelectTravelFeeModal from "components/common/TravelFeeModal";
import CouldNotCover from "components/appointment/CouldNotCover";
import FullPageLoader from "components/common/FullPageLoader";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import { usePermissions } from "layouts/Admin";
import AddPatient from "components/appointment/AddPatient";
import ApprovalModal from "components/appointment/ApprovalModal";
import useTimeZoneClock from "hooks/useTimeZoneClock";
import moment from "moment";
import ViewTable from "./ViewTable";
import Api from "services/api";
import { setIframeUrl } from "slices/iframeSlice";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Trash2, Video } from "lucide-react";
import TagInput from "components/TagInput";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Modal } from "bootstrap";
import { CloseButton } from "reactstrap";
import ErrorMessage from "components/common/ErrorMessage";
import CasesTable from "./CasesTable";
import ApiLogsTable from "components/appointment/ApiLogsTable";
import NotificationLogsTable from "components/appointment/NotificationLogsTable";

const AppointmentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [donotCover, setDonotCover] = React.useState(false);
  const [addPatient, setAddPatient] = React.useState(false);
  const [couldNotCover, setCouldNotCover] = React.useState(false);
  const [approval, setApproval] = React.useState(false);
  const [assignInterpreter, setAssignInterpreter] = React.useState(false);
  const [rescheduleModal, setRescheduleModal] = React.useState(false);
  const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
  const [travelFeeModal, setTravelFeeModal] = React.useState(false);
  const [recordingUrl, setRecordingUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  console.log('asdasd',item);

  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);

  const callViewApi = async () => {
    const callBack = (success, message, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
        // console.log(data)
      } else {
        console.log(message);
      }
      // setItem()
    };

    dispatch(fetchAppointmentView(id, callBack));
  };

  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
        // console.log(data)
      } else {
        console.log(message);
      }
      // setLogs()
    };
    dispatch(fetchAppointmentLogs(id, callBack));
  };

  React.useEffect(() => {
    setLoading(true);
    callViewApi();
    fetchLogs();
  }, [id]);

  const handleCancel = () => {
    setCancelModal(true);
  };
  const handleCloseCancel = () => {
    setCancelModal(false);
  };
  const handleDonotCover = () => {
    setDonotCover(true);
  };
  const handleCloseDonotCover = () => {
    setDonotCover(false);
  };

  const handleAddPatient = () => {
    setAddPatient(true);
  };
  const handleCloseAddPatient = () => {
    setAddPatient(false);
  };

  const handleApproval = () => {
    setApproval(true);
  };
  const handleCloseApproval = () => {
    setApproval(false);
  };

  const handleCouldNotCover = () => {
    setCouldNotCover(true);
  };
  const handleCloseCouldNotCover = () => {
    setCouldNotCover(false);
  };
  const handleReschedule = () => {
    setRescheduleModal(true);
  };
  const handleCloseReschedule = () => {
    setRescheduleModal(false);
  };
  const handleAssignInterpreter = () => {
    setAssignInterpreter(true);
  };
  const handleTravelFeeModal = () => {
    setTravelFeeModal(true);
  };
  const handleCloseAssignInterpreter = () => {
    setAssignInterpreter(false);
  };
  const handleCloseTravelFeeModal = () => {
    setTravelFeeModal(false);
  };
  const handleOpenCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(true);
  };
  const handleCloseCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(false);
  };

  const handleRemoveInterpreter = () => {
    new Swal({
      title: "Remove Interpreter?",
      text: "This will remove the assigned interpreter and reopen the job. All invited interpreters will be re-notified.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        dispatch(setActionAssign(id, {}, 'remove-interpreter', (success, message) => {
          setLoading(false);
          if (success) {
            callViewApi();
            fetchLogs();
            toast.success(message, { className: "successToast" });
          } else {
            toast.error(message, { className: "errorToast" });
          }
        }));
      }
    });
  };

  const handleUncomplete = () => {
    new Swal({
      title: "Uncomplete Job?",
      text: "This will revert the job to Assigned and remove it from the billing report until it is completed again. Check-in/out times are kept.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, uncomplete",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        dispatch(setActionAssign(id, {}, 'uncomplete', (success, message) => {
          setLoading(false);
          if (success) {
            callViewApi();
            fetchLogs();
            toast.success(message, { className: "successToast" });
          } else {
            toast.error(message, { className: "errorToast" });
          }
        }));
      }
    });
  };

  const editFormSubmitCallback = () => {
    callViewApi();
  };


  useEffect(() => {
    editFormSubmitCallback()
  }, [appointmentPopUpState]);


  const handleEditAppointmentPopUp = () => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        popupType: "edit",
        item,

      })
    );
  };
  const handleCopyAppointmentPopUp = () => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        popupType: "copy",
        item,
      })
    );
  };
  const handleCloseEditApptPopup = () => {
    dispatch(closeAppointmentPopup());
  };

  const handleSubmit = (data, end_point, callBack) => {
    setLoading(true);
    const submitCallback = (success, message, body) => {
      callBack && callBack();
      if (success) {
        handleCloseCancel();
        handleCloseDonotCover();
        handleCloseCouldNotCover();
        handleCloseReschedule();
        handleCloseAssignInterpreter();
        handleCloseTravelFeeModal();
        handleCloseEditApptPopup();
        handleCloseCheckinCheckoutModal();
        handleCloseAddPatient();
        handleCloseApproval();
        callViewApi();
        fetchLogs();
        toast.success(message, {
          className: "successToast",
        });
        setLoading(false);
        // scheduleDetailModal?.show && openModal()
      } else if (body?.errors?.conflict) {
        // Interpreter is double-booked (or within their buffer) — admin may override
        setLoading(false);
        new Swal({
          title: "Schedule Conflict",
          text: message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, book anyway",
        }).then((result) => {
          if (result.isConfirmed) {
            setLoading(true);
            dispatch(setActionAssign(id, { ...data, force_assign: 1 }, end_point, submitCallback));
          }
        });
      } else {
        toast.error(message, {
          className: "errorToast",
        });
        setLoading(false);
      }
    };
    dispatch(setActionAssign(id, data, end_point, submitCallback));
  };



  const handleRemove = () => {
    const callBack = (success, message) => {
      if (success) {
        new Swal({
          title: message,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        navigate("/", { replace: true });
      } else {
        new Swal({
          title: message,
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    };
    new Swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeAppointment(id, callBack));
      }
    });
  };

  const navigateToInviteInterpreter = () => {
    // window.location.href = `/invite-interpreter/${id}`;
    navigate(`/appointments/invite-interpreter/${id}`);
  };
  const mileageCheck = (val) => {
    return item?.appointment_details?.[val];
  };

  const rawDatetime = item?.datetime;

  const parsedDatetime = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss");
  const formattedDate = parsedDatetime.isValid()
    ? parsedDatetime.format("MMM D, YYYY hh:mm A") + " (PST)"
    : "";
  const {
    formState: { errors },
    control,
    setValue,
  } = useForm();
  const appointmentId = id;

  //   Join Video Call handler
  const handleJoinVideoCall = async () => {
    // // Check if appointment is today
    // const today = moment().format("YYYY-MM-DD");
    // const appointmentDate = item?.date || (item?.datetime ? moment(item.datetime).format("YYYY-MM-DD") : null);
    // if (!appointmentDate || appointmentDate !== today) {
    //   toast.error("You can only join the video call on the appointment day.", { className: "errorToast" });
    //   return;
    // }
    try {
      const response = await Api.adminjoinVideoCall(appointmentId);
      if (response?.status === 200) {
        const iframeUrl = response?.data?.data?.iframe_url;
        dispatch(setIframeUrl(iframeUrl));
        navigate(`/appointments/view/join-room-call/${appointmentId}`);
        // console.log("Joined successfully:", response?.data?.data?.iframe_url);
        // console.log("Joined successfully:", response);
      } else {
        const errorMsg =
          response?.data?.statusText ||
          response?.data?.message ||
          response?.data?.error;
        console.error("Failed to join:", errorMsg);
        toast.error(errorMsg, { className: "errorToast" });
      }
    } catch (err) {
      console.error("Error joining video call:", err);
      toast.error("Error joining video call.", { className: "errorToast" });
    }
  };

  const showRecordingPopup = () => {
    if (item?.appointment_details?.recording) {
      setRecordingUrl(item.appointment_details.recording);
      setShowModal(true);
    } else {
      toast.error("Recording not available for this appointment.", {
        className: "errorToast",
      });
    }
  };

  const [inviteGuestPopup, setInviteGuestPopup] = React.useState({
    open: false,
    documents: [],
  });

  // Invites Guest Popup
  const InviteGuestPopup = ({ open, item, onClose, appointmentId }) => {
    const [loading, setLoading] = useState(false);
    const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({
      defaultValues: {
        emailArray: item?.appointment_details?.requester_email
          ? item.appointment_details.requester_email
            .split(",")
            .map((email) => ({ email: email.trim() }))
          : [{ email: "" }],
      },
    });

    const { fields, append, remove } = useFieldArray({
      control,
      name: "emailArray",
    });

    const onSubmit = async (data) => {
      const emails = data.emailArray
        .map((item) => item.email.trim())
        .filter(Boolean);
      // console.log("Emails to send:", emails);

      try {
        setLoading(true);
        const payload = { requester_email: emails };
        const response = await Api.inviteGuests(appointmentId, payload);
        console.log("res", response);
        toast.success(response?.data?.message);
        setLoading(false);
        setInviteGuestPopup({
          open: false,
          documents: [],
        });
        callViewApi();
      } catch (error) {
        setLoading(false);
        console.log("error", error);
      }
    };

    if (!open) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.3)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
          boxSizing: "border-box",
        }}
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            background: "#fff",
            borderRadius: 12,
            minWidth: 500,
            maxWidth: 900,
            width: "40%",
            maxHeight: "100%",
            padding: 32,
            boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
            position: "relative",
            overflowY: "auto",
          }}
        >
          <button
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              background: "none",
              border: "none",
              fontSize: 22,
              cursor: "pointer",
            }}
            onClick={onClose}
            aria-label="Close"
            type="button"
          >
            <CloseButton style={{ width: 10, height: 10 }} />
          </button>
          <h2 style={{ marginBottom: 24 }}>Invite Guests</h2>

          {/* Render dynamic email inputs */}
          {fields.map((field, index) => (
            <div key={field.id} className="w-100 row-primary">
              <Controller
                name={`emailArray.${index}.email`}
                control={control}
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                    message: "Invalid email format",
                  },
                }}
                defaultValue={field.email}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    {...field}
                    type="email"
                    placeholder="Email"
                    style={{ flexGrow: 1, marginRight: 8 }}
                  />
                )}
              />
              <button
                type="button"
                onClick={() => remove(index)}
                style={{
                  background: "red",
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  padding: "6px 14px",
                  cursor: "pointer",
                }}
              >
                <Trash2 style={{ width: 16, height: 16 }} />
              </button>
            </div>
          ))}

          {/* Show validation error for each email */}
          {errors.emailArray &&
            errors.emailArray.map((error, idx) =>
              error?.email ? (
                <div
                  key={idx}
                  style={{ color: "red", marginBottom: 10, fontSize: 12 }}
                >
                  {error.email.message}
                </div>
              ) : null
            )}

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <button
              type="button"
              onClick={() => append({ email: "" })}
              style={{
                padding: "10px 16px",
                borderRadius: 6,
                border: "1px solid #888",
                background: "white",
                cursor: "pointer",
              }}
            >
              Add Email
            </button>

            <SubmitButton
              buttonType="submit"
              className={"button"}
              btnText="Send Invite"
              disabled={loading}
              loader={loading}
            />
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="content" style={{}}>
      {loading && <FullPageLoader />}
      {/* <did */}
      <div className="row_main_head bg-primary-secondaryCard p-3">
        <h2 className={`main_heading main_heading1`}>
          View Job # {item?.appid}
        </h2>
         <h2 className={`main_heading main_heading1`}>
          Status : {effectiveStatus(item)}
        </h2>
      </div>

      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2 appview`} toLowerCase={"text-lowercase"}>
          Date & Time <span className="dateTime">{formattedDate}</span>
        </h2>
        <h2 className={`main_heading2`} toLowerCase={"text-lowercase"}>
          language <span className="dateTime">{item?.language?.name}</span>
        </h2>
      </div>

      <div className="card_table view_table_custom">
        {mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == null ? (
          <div className="row_main_head align-items-center softAlert waiting">
            <h3>The vendor has requested extra mileage</h3>
            {checkPermission("Extra Mileage") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="View Request"
                handleSubmit={handleApproval}
              />
            )}
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 1 ? (
          <div className="softAlert approved">
            <h3>
              The extra mileage request for this appointment have been approved.
            </h3>
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 0 ? (
          <div className="softAlert rejected">
            <h3>
              The extra mileage request for this appointment have been rejected.
            </h3>
          </div>
        ) : (
          ""
        )}

        <div className="row-primary flex-wrap justify-content-between">
          <div className="row-primary flex-wrap">
            {checkPermission("Copy Appointment") && item?.status !== "cancelled" &&  (
              <SubmitButton
                buttonType="button"
                className={"lightPurple"}
                btnText="Copy"
                handleSubmit={handleCopyAppointmentPopUp}
              />
            )}
            {checkPermission("Assign Appointment") && item?.status !== "cancelled" && item?.status !== "completed" &&  (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText={(item.status == 'assigned') ? 'Reassign' : 'Assign'}
                handleSubmit={handleAssignInterpreter}
              />
            )}
            {checkPermission("Assign Appointment") && item?.status === "assigned" && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText="Remove Interpreter"
                handleSubmit={handleRemoveInterpreter}
              />
            )}
            {checkPermission("Assign Appointment") && item?.status === "completed" && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText="Uncomplete Job"
                handleSubmit={handleUncomplete}
              />
            )}
            {checkPermission("Travel Fee") && item?.status !== "cancelled" && item?.status !== "completed" &&  (
              <SubmitButton
                buttonType="button"
                // className={"green"}
                btnText="Travel Fee"
                handleSubmit={handleTravelFeeModal}
              />
            )}
            {checkPermission("Edit Appointments") && item?.status !== "cancelled" && item?.status !== "completed" &&  (
              <SubmitButton
                buttonType="button"
                className={"lightGrey"}
                btnText="Edit"
                handleSubmit={handleEditAppointmentPopUp}
              />
            )}
            {checkPermission("Reschedule Appointment") && item?.status !== "cancelled" && item?.status !== "completed" &&  (
              <SubmitButton
                buttonType="button"
                className={"lightBlue"}
                btnText="Reschedule"
                handleSubmit={handleReschedule}
              />
            )}
            {checkPermission("Donot Cover") && item?.status !== "dnc" && item?.status !== "cancelled" &&  (
              <SubmitButton
                buttonType="button"
                btnText="Do Not Cover"
                className="yellow"
                handleSubmit={handleDonotCover}
              />
            )}
            {checkPermission("Could Not Cover") && item?.status !== "cnc" && item?.status !== "cancelled" &&  (
              <SubmitButton
                buttonType="button"
                btnText="Could Not Cover"
                className="yellow"
                handleSubmit={handleCouldNotCover}
              />
            )}
            {checkPermission("Cancel Appointment") &&
              item?.status !== "cancelled" && item?.status !== "completed" && (
                <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText="Cancel"
                  handleSubmit={handleCancel}
                />
              )}
            {checkPermission("Check-in/Check-out") && item?.status !== "cancelled" && item?.status !== "completed" && item?.status !== "open" &&  (
              <SubmitButton
                buttonType="button"
                className="Cancle_button"
                btnText="Checkin / checkout"
                data-bs-toggle="modal"
                data-bs-target="#checkinCheckoutAdjustmentModal"
                handleSubmit={handleOpenCheckinCheckoutModal}
              />
            )}
          </div>
        </div>

        {/* Pending only: once the request is actioned (interpreter removed → open, or job
            reassigned to someone else) the banner must disappear — so it shows only while
            the job is still assigned to the interpreter who made the request */}
        {item?.logs?.length > 0 && item?.status === "assigned" && item?.logs?.[0]?.user_id === item?.interpreter?.user_id && (
          <div style={{ background: '#fde8e8', borderLeft: '4px solid #dc3545', padding: '12px 16px', margin: '12px 0', borderRadius: 4, color: '#7b1d1d' }}>
            <strong>Cancellation Requested by Interpreter</strong>
            <div style={{ marginTop: 4, fontSize: 14 }}>
              <span>Requested on: {moment(item.logs[0].date + ' ' + item.logs[0].time, 'YYYY-MM-DD hh:mm a').format('MMM D, YYYY h:mm A')}</span>
              {item.logs[0].notes && <div style={{ marginTop: 4 }}>Reason: {item.logs[0].notes}</div>}
            </div>
          </div>
        )}
        <ViewTable item={item} />

        <div className="d-flex gap-2 justify-content-between align-items-center mt-3">
          <div className="d-flex gap-2 justify-content-start align-items-center flex-wrap">
            {checkPermission("Invite Interpreter") && item?.status !== "cancelled" && item?.status !== "completed" && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="Invite Interpreters"
                handleSubmit={navigateToInviteInterpreter}
              />
            )}
            {/* {checkPermission("Delete Appointments") && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText="Remove this Appointment"
                handleSubmit={handleRemove}
              />
            )} */}
          </div>

          {/* View Recording Button  */}
          {item?.appointment_details?.recording && (
            <SubmitButton
              className="Cancle_button"
              btnText="View Recording"
              handleSubmit={showRecordingPopup}
            />
          )}
        </div>
      </div>
      {checkPermission('View Cases') && (
      <div className="card_table p-4">
        <CasesTable appointment={item} formattedDate={formattedDate} onCaseChange={fetchLogs} />
      </div>)}

      {checkPermission('View Logs') && (
      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Job Logs</h2>
        </div>
        <LogsTable logs={logs} />
      </div>)}

      {checkPermission('View API Logs') && <ApiLogsTable appointmentId={id} />}

      {checkPermission('View Notification Logs') && <NotificationLogsTable appointmentId={id} />}

      <SelectInterpreterModal
        isOpen={assignInterpreter}
        onClose={handleCloseAssignInterpreter}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <SelectTravelFeeModal
        isOpen={travelFeeModal}
        onClose={handleCloseTravelFeeModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <CancelModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <DonotCover
        isOpen={donotCover}
        onClose={handleCloseDonotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <AddPatient
        isOpen={addPatient}
        onClose={handleCloseAddPatient}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CouldNotCover
        isOpen={couldNotCover}
        onClose={handleCloseCouldNotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <RescheduleModal
        isOpen={rescheduleModal}
        onClose={handleCloseReschedule}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <CheckinCheckoutAdjustmentModal
        isOpen={checkinCheckoutModal}
        handleClose={handleCloseCheckinCheckoutModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        onSubmit={handleSubmit}
        item={item}
        loader={loading}
      />
      <ApprovalModal
        isOpen={approval}
        onClose={handleCloseApproval}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
      <InviteGuestPopup
        appointmentId={id}
        open={inviteGuestPopup.open}
        item={item}
        onClose={() => setInviteGuestPopup({ open: false, documents: [] })}
      />
    </div>
  );
};

export default AppointmentView;
